// Smooth scroll to the target element
export const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>): void => {
  event.preventDefault();
  const targetId = event.currentTarget.getAttribute('href')?.substring(1);
  if (targetId) {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
};
